import { render, staticRenderFns } from "./ClaimDropdown.vue?vue&type=template&id=31a246c6&scoped=true&"
import script from "./ClaimDropdown.vue?vue&type=script&lang=js&"
export * from "./ClaimDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDropdown.vue?vue&type=style&index=0&id=31a246c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a246c6",
  null
  
)

export default component.exports